import { FC, MouseEvent } from 'react';

import { Icon } from '@purpur/library/icon';
import { close } from '@purpur/library/icon/assets/close';
import { search } from '@purpur/library/icon/assets/search';
import { time } from '@purpur/library/icon/assets/time';

import { DeleteButton, StyledIcon, SuggestionLink } from './ListSuggestionItem.styles';
import { ListSuggestionItemProps } from './model';

const LIST_SUGGESTION_ITEM_DELETE_BUTTON = 'list-suggestion-item-delete-button';

const escapeRegExp = (text: string) => {
    return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};

export const ListSuggestionItem: FC<ListSuggestionItemProps> = ({
    keyword,
    searchText,
    url,
    isHistory,
    onDelete,
    onClick,
}) => {
    const parts = searchText ? keyword.split(new RegExp(`(${escapeRegExp(searchText)})`, 'gi')) : [keyword];

    const handleDelete = (e: MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        onDelete?.();
    };

    return (
        <SuggestionLink href={url} onClick={onClick}>
            <StyledIcon svg={isHistory ? time : search} size="md" />
            <div>
                {isHistory
                    ? keyword
                    : parts.map((part, index) =>
                          part.toLowerCase() === searchText?.toLowerCase() ? part : <b key={index}>{part}</b>,
                      )}
            </div>
            {isHistory && (
                <DeleteButton onClick={handleDelete} data-test={LIST_SUGGESTION_ITEM_DELETE_BUTTON}>
                    <Icon svg={close} size="md" />
                </DeleteButton>
            )}
        </SuggestionLink>
    );
};
